var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"background-color":"red","color":"white","z-index":"100","text-align":"center","position":"relative","display":"none"}},[_vm._v(" "+_vm._s(_vm.previousGridRoute?.fullPath)+" > "+_vm._s(_vm.previousPathRoute?.fullPath)+" > "+_vm._s(_vm.currentRoute?.fullPath)+" ")]),(_vm.appConfig)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }